import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';

export const OrderContextMenu = ({ contextMenu, closeContextMenu }) => {
  const { setShowRelatedOrdersMenu, setShowManageRelatedOrdersMenu, setOrder, order, setShowOrderAccommodationPrefixDialog } = useAccomodationDiagram();

  const handleOpenRelatedOrdersMenu = () => {
    setOrder(contextMenu.order);
    setShowRelatedOrdersMenu(true);
    closeContextMenu();
  };

  const handleOpenManageRelatedOrdersMenu = () => {
    setOrder(contextMenu.order);
    setShowManageRelatedOrdersMenu(true);
    closeContextMenu();
  };

  if (!order) {
    return null;
  }

  return (
    <Menu
      open={contextMenu !== null}
      onClose={closeContextMenu}
      anchorReference="anchorPosition"
      anchorPosition={
        contextMenu !== null
          ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
          : undefined
      }
    >
      {!order.relatedGroup ? <MenuItem onClick={handleOpenRelatedOrdersMenu}>Przypisz do grupy zakwaterowania</MenuItem>
        : <MenuItem onClick={handleOpenManageRelatedOrdersMenu}>Zarządzaj grupą zakwaterowania</MenuItem>}
      <MenuItem onClick={() => setShowOrderAccommodationPrefixDialog(true)}>Zmień prefix</MenuItem>
    </Menu>
  );
};
